/*
 * @fileName:
 * @Date: 2021-04-25 17:06:01
 * @Author: manyao.zhu
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import global_ from './components/Global'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import { I18nClient } from './scripts/AllExport'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './../static/fonts/font.css'

// Import our CSS
// import './../static/scss/robust.scss'

// Robust's components
// import './../static/js/modules/bootstrap'
// import './../static/js/modules/timeago'
import './../static/js/modules/flickity'
import './../static/js/modules/medium-zoom'
import './../static/js/modules/countdown'
import router from './router'
import App from './App'

require('layui-layer')

Vue.prototype.GLOBAL = global_
Vue.use(ElementUI, { locale })

Vue.use(VueI18n)

const i18n = I18nClient.createI18n()

/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  console.log(to)

  Vue.nextTick(function () {
    if (window.name === '') {
      console.log('首次被加载')
      app.loadingAll = true
      setTimeout(() => {
        app.routerShow = true
        app.loadingAll = false
      }, 2600)
      next()
      window.name = 'isRefresh'
    } else if (window.name === 'isRefresh') {
      console.log('页面被刷新')
      app.routerShow = true
      app.loadingAll = false
      next()
    }

    // else {
    //   app.loadingAll = false
    //   app.loading = true
    //   setTimeout(() => {
    //     app.routerShow = true
    //     app.loading = false
    //   }, 1200)
    // }
  })
})

router.afterEach((to, from, next) => {
  // if (to.path === '/') {
  //   console.log('afterEach')
  //   setTimeout(() => {
  //     app.loadingAll = false
  //   }, 2000)
  // } else {
  //   setTimeout(() => {
  //     app.loading = false
  //   }, 1500)
  // }
})

const app = new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
  data: { loadingAll: true, routerShow: false }
})



// WEBPACK FOOTER //
// ./src/main.js